import { Inject, Injectable } from '@angular/core';
import { TChatbotEnvironmentVars } from '@monorepo/types';

@Injectable({ providedIn: 'root' })
export class ChatbotEnvironmentService {
  readonly #webSocketUrl: string;

  constructor(@Inject('chatbotEnvironment') envValues: TChatbotEnvironmentVars) {
    const { protocol, chatbot_host, chatbot_ws_path } = envValues;
    this.#webSocketUrl = protocol + chatbot_host + chatbot_ws_path;
  }

  getWebSocketUrl(): string {
    return this.#webSocketUrl;
  }
}
